import { Navigate, createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Main from '@pages/Main';
import ProfileLayout from '@pages/profile/ProfileLayout';
import Profile from '@pages/profile/Profile';
import Contacts from '@pages/profile/Contacts';
import Notifications from '@pages/profile/Notifications';
import ChangePassword from '@pages/profile/ChangePassword';
import { NotFoundPage } from '@pages/not-found/NotFound';
import TicketsLayout from '@pages/tickets/TicketsLayout';
import TicketsByEvent from '@pages/tickets/events/TicketsByEvent';
import OrdersPage from '@pages/orders/OrdersPage';
import EventDetails from '@pages/tickets/event-details';
import SeasonPassLayout from '@pages/season_pass/SeasonPassLayout';
import SeasonPassTickets from '@pages/season_pass/tickets/SeasonPassTickets';
import SeasonPassEventDetails from '@pages/season_pass/event-details';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/profile" replace />,
      },
      {
        path: 'orders',
        element: <OrdersPage />,
      },
      {
        path: 'profile',
        element: <ProfileLayout />,
        children: [
          {
            path: 'notifications',
            element: <Notifications />,
          },
          {
            path: 'contacts',
            element: <Contacts />,
          },
          {
            path: 'password',
            element: <ChangePassword />,
          },
          {
            path: '',
            element: <Profile />,
          },
        ],
      },
      {
        path: 'tickets',
        element: <TicketsLayout />,
        children: [
          {
            path: 'events',
            element: <TicketsByEvent />,
          },
          {
            path: 'events/:eventId',
            element: <EventDetails />,
          },
          {
            path: '',
            element: <Navigate to="events" replace />,
          },
        ],
      },
      {
        path: 'season_pass',
        element: <SeasonPassLayout />,
        children: [
          {
            path: 'tickets',
            element: <SeasonPassTickets />,
          },
          {
            path: 'tickets/events/:eventId',
            element: <SeasonPassEventDetails />,
          },
          {
            path: '',
            element: <Navigate to="tickets" replace />,
          },
        ]
      }
    ],
  },
]);

export default router;
